export default (app) => {
  app.on("loaded", async () => {
    const { data } = await app.database.language.search({ sortby: ["position"] });
    if (!data) return;

    const { value } = await app.storage.getItem({ id: "language" });
    const language = data.find(({ _id }) => _id === value) || data.find((language) => language.default) || data[0];
    app.storage.setItem({ id: "language", value: language._id });
  });
};
